module.exports = {
      id: "ecg-graph-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#ecg-graph-usage",
      toString: function () {
        return this.url;
      }
    }